const tabHasNewSignupsOfType = (signupType, signups) => {
  const newSignups = signups.filter(({ status, entityType }) => {
    return entityType === signupType && status === 'pending';
  });

  return newSignups.length > 0;
};

export default tabHasNewSignupsOfType;
